export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-thumbnail-960-78e7d48ec13f60d388e895d973496f38.webp";